import styled from 'styled-components';
import { MdDelete, MdEdit, MdVisibility } from 'react-icons/md';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const WrapperTable = styled.div`
  width: 100%;
  margin-top: 20px;
  
`;

export const WrapperAdd = styled.div`
  margin-left: 10px;
`;

export const DeleteIcon = styled(MdDelete)`
  cursor: pointer;
  color: #f27160;
  font-size: 20px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
`;

export const EditIcon = styled(MdEdit)`
  cursor: pointer;
  color: #122d58;
  font-size: 20px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
`;

export const ViewIcon = styled(MdVisibility)`
  cursor: pointer;
  color: #2196F3;
  font-size: 20px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
`;

export const WrapperPopover = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PopoverText = styled.p`
  font-size: 14px;
  color: #333;
  margin-bottom: 15px;
`;

export const PopoverButton = styled.button`
  padding: 8px 20px;
  margin: 0 5px;
  border: none;
  border-radius: 3px;
  background-color: ${props => props.primary ? '#122d58' : '#DEDEDE'};
  color: ${props => props.primary ? '#fff' : '#333'};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`;

